export default "__VITE_ASSET__q_2O2T$z__"